export function referrerFromProductPage(slotId: string, previousUrl: string) {
	const [productId] = slotId.split(':')
	return (
		!!productId &&
		/\/p\//.test(previousUrl) &&
		previousUrl.indexOf(productId) > -1
	)
}
